export enum FileSelectorMimeType {
	Folders = "Folders",
	AllFiles = "AllFiles",
	SharedDrives = "SharedDrives",
}
